'use strict';

module.exports = function (str) {
		return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-time-picker/lib/toUpperFirst.js
// module id = 1456
// module chunks = 0